export const APP_STORE_URL = 'https://apps.apple.com/us/app/lown-loan-to-own/id6751429599';
export const APP_STORE_ROUTE = '/app-store';
